import BaseService from "../base/base.service";

export default class TenderService extends BaseService {
    constructor() {
        super('Tender')
    }
}